import { render, staticRenderFns } from "./bgSkeletonSSOMobile.vue?vue&type=template&id=0399867f&scoped=true"
import script from "./bgSkeletonSSOMobile.vue?vue&type=script&lang=js"
export * from "./bgSkeletonSSOMobile.vue?vue&type=script&lang=js"
import style0 from "./bgSkeletonSSOMobile.vue?vue&type=style&index=0&id=0399867f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0399867f",
  null
  
)

export default component.exports